<template>
  <div class="addSchedule">
    <el-dialog
      :visible.sync="dialog.visible"
      :show-close=false
      :before-close="handleClose">
      <div class="title">{{title}}</div>
      <split></split>
      <div class="form_body">
        <el-form ref="schedule_form" :model="form" label-width="0">
          <el-form-item class="schedule_content">
            <el-input
              v-model="form.title"
              placeholder="请输入日程内容"
              :disabled="!editable">
            </el-input>
          </el-form-item>
          <split></split>
          <el-form-item class="start_end_time">
            <div class="label_icon"> <i class="el-icon-time"></i></div>
            <div class="sub_title">选择时间</div>
            <div class="date_picker">
              <el-date-picker
                v-model="start_end_time"
                type="datetimerange"
                :editable=false
                placeholder="添加时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                range-separator="至"
                :disabled="!editable">
              </el-date-picker>
            </div>
          </el-form-item>
         <!-- <el-form-item class="start_time">
            <div class="label_icon"> <i class="el-icon-time"></i></div>
            <div class="sub_title">开始时间</div>
            <div class="date_picker">
              <el-date-picker
                v-model="form.start_time"
                type="datetime"
                :editable=false
                placeholder="添加时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :picker-options="pickerOptionsStart"
                :disabled="!editable">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item class="end_time">
           <div class="label_icon"> <i class="el-icon-time"></i></div>
            <div class="sub_title">结束时间</div>
            <div class="date_picker">
              <el-date-picker
                v-model="form.end_time"
                type="datetime"
                :editable=false
                placeholder="添加时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :picker-options="pickerOptionsEnd"
                :disabled="!editable">
              </el-date-picker>
            </div>
          </el-form-item>-->
          <el-form-item>
            <div class="label_icon"> <i class="icon iconfont icon-biaoqian2"></i></div>
            <div class="sub_title">类型</div>
            <div class="sub_title_2">
              <el-radio-group v-model="form.category" :disabled="!editable">
                <el-radio-button v-for="cat in categoryList" :key="cat.id" :label="cat.id">{{cat.name}}</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="label_icon"> <i class="icon iconfont icon-xunhuan101"></i></div>
            <div class="sub_title">重复</div>
            <div class="sub_title_2">
              <el-radio-group v-model="form.cycle" :disabled="!editable">
                <el-radio-button label="0">无</el-radio-button>
                <el-radio-button label="1">每天</el-radio-button>
                <el-radio-button label="2">每周</el-radio-button>
                <el-radio-button label="3">每月</el-radio-button>
                <el-radio-button label="5">每年</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="label_icon"><i class="el-icon-bell"></i></div>
            <div class="sub_title">提醒</div>
            <el-select class="remind_time_id_select" v-model="form.remind_time_id" placeholder="设置提醒时间" clearable :disabled="!editable">
             <!-- <el-option label="无" value="none"></el-option>-->
              <el-option v-for="remind in remindTimeList" :key="remind.remind_time_id" :label="remind.remind_name" :value="remind.remind_time_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.category === 4">
            <div class="label_icon"><i class="icon iconfont icon-project_space"></i></div>
            <div class="sub_title">项目</div>
            <el-select class="team_no_select" v-model="form.team_no" placeholder="选择项目" clearable :disabled="!editable">
              <!--<el-option label="无" value="none"></el-option>-->
              <el-option v-for="project in projectList" :key="project.team_no" :label="project.team_name" :value="project.team_no"></el-option>
            </el-select>
          </el-form-item>
          <split></split>
          <el-form-item class="schedule_mark">
            <el-input
              v-model="form.content"
              placeholder="备注"
              type="textarea"
              :rows="3"
              :disabled="!editable">
            </el-input>
          </el-form-item>
          <split></split>
          <div class="form_buttons">
            <el-button class="cancel_btn" @click.stop="cancelDialog">
              <span v-if="editable">取消</span>
              <span v-else>返回</span>
            </el-button>
            <el-button v-if="dialog.method === 'add'" class="confirm_btn" type="primary" @click.stop="addSchedule" :class="{disableBtn: isDisable}">发布<i class="icon iconfont icon-fabu2"></i></el-button>
            <el-button v-if="(dialog.method === 'edit') && editable" class="confirm_btn" type="primary" @click.stop="editSchedule" :class="{disableBtn: isDisable}">发布<i class="icon iconfont icon-fabu2"></i></el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import split from './split_line_2px.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
// import moment from 'moment'
export default {
  name: 'addSchedule',
  components: {
    split
  },
  computed: {
    ...mapState([
      'scheduleDialog',
      'selectDate',
      'categoryList',
      'remindTimeList',
      'projectList',
      'userInfo'
    ]),
    isDisable () {
      return this.form.title === '' || this.form.category === '' || (this.form.category === 4 && this.form.team_no === '')
    },
    pickerOptionsStart () {
      return {
        disabledDate: (time) => {
          return time.getTime() > moment(this.form.end_time).format('x')
        }
      }
    },
    pickerOptionsEnd () {
      return {
        disabledDate: (time) => {
          return time.getTime() < moment(this.form.start_time).format('x')
        }
      }
    },
    start_end_time: {
      get: function () {
        return [this.form.start_time, this.form.end_time]
      },
      set: function (newVal) {
        let startEndTime = newVal
        console.log(startEndTime)
        console.log(startEndTime[0])
        console.log(startEndTime[1])
        this.form.start_time = startEndTime[0]
        this.form.end_time = startEndTime[1]
      }
    }
  },
  data: function () {
    return {
      form: {
        user_no: this.$store.state.userInfo.user_no, // 任务执行者
        create_user: this.$store.state.userInfo.user_no, // 任务创建者
        update_user: this.$store.state.userInfo.user_no, // 任务更新者
        title: '',
        content: '',
        category: '',
        start_time: '',
        end_time: '',
        team_no: '',
        cycle: 0,
        remind_time: '',
        remind_time_id: '',
        task_no: ''
      },
      dialog: {
        visible: false,
        method: '',
        no: ''
      },
      category_list: [],
      remind_time_list: [],
      title: '',
      editable: true
    }
  },
  watch: {
    selectDate: function (newVal, oldVal) {
      this.form.start_time = newVal
      this.form.end_time = newVal
    },
    scheduleDialog: {
      handler (newVal, oldVal) {
        let _this = this
        this.dialog.visible = newVal.visible
        this.dialog.method = newVal.method
        this.dialog.no = newVal.no
        let method = newVal.method
        let taskNo = newVal.no
        this.form.task_no = taskNo
        if (method === 'edit') {
          _this.title = '编辑日程'
          axios({
            method: 'get',
            url: _this.HOST + '/task/getTaskDetail',
            params: {
              task_no: taskNo
            }
          }).then((res) => {
            let data = res.data
            console.log('日程详情')
            console.log(data)
            if (data.statusCode === 200) {
              let task = data.data
              let createUser = task.user_no
              let status = task.status
              _this.form.title = task.title
              _this.form.content = task.content
              _this.form.category = task.category
              _this.form.start_time = new Date(moment(task.start_time).format('YYYY-MM-DD HH:mm'))
              _this.form.end_time = new Date(moment(task.end_time).format('YYYY-MM-DD HH:mm'))
              _this.form.team_no = task.team_no
              _this.form.cycle = task.cycle
              _this.form.remind_time = task.remind_time
              if (createUser === _this.userInfo.user_no) {
                _this.editable = true
              } else {
                _this.editable = false
                _this.title = '查看日程'
              }
              if (status === 2) {
                _this.editable = false
                _this.title = '查看日程'
              }
              // 后台0为不提醒
              if (task.remind_time_id === 0) {
                task.remind_time_id = ''
              }
              _this.form.remind_time_id = task.remind_time_id
            } else {
              console.log(data.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.title = '添加日程'
          _this.editable = true
          _this.form.start_time = new Date(moment(_this.selectDate).format('YYYY-MM-DD HH:mm'))
          _this.form.end_time = new Date(moment(_this.selectDate).format('YYYY-MM-DD HH:mm'))
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleClose () {
      console.log('handle dialog close')
      // this.cancelDialog()
    },
    closeAddProjectDialogVisible () {
      this.addScheduleDialogVisible = false
    },
    addSchedule () {
      console.log(JSON.stringify(this.form))
      if (this.isDisable) {
        console.log('isDisable')
        return
      }
      this.preHandleParams()
      console.log(JSON.stringify(this.form))
      let _this = this
      axios({
        method: 'post',
        url: _this.HOST + '/task/addTask',
        params: _this.form
      }).then(res => {
        let data = res.data
        console.log('创建日程')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setTodayScheduleList')
          _this.$store.dispatch('setCalanderRefresh', true)
          _this.cancelDialog()
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    editSchedule () {
      if (this.isDisable) {
        console.log('isDisable')
        return
      }
      this.preHandleParams()
      console.log(JSON.stringify(this.form))
      let _this = this
      axios({
        method: 'post',
        url: _this.HOST + '/task/updateTask',
        params: _this.form
      }).then(res => {
        let data = res.data
        console.log('编辑日程')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setTodayScheduleList')
          _this.$store.dispatch('setCalanderRefresh', true)
          _this.cancelDialog()
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    preHandleParams () {
      let startTime = this.form.start_time
      // 计算提醒时间
      if (this.form.remind_time_id === '') {
        this.form.remind_time_id = 0
        this.form.remind_time = ''
      } else {
        // remind_time_id:
        // 1:日程开始时
        // 2:提前5分钟
        // 3:提前15分钟
        // 4:提前30分钟
        // 5:提前1小时
        // 6.提前1天
        if (this.form.remind_time_id === 1) {
          this.form.remind_time = startTime
        } else if (this.form.remind_time_id === 2) {
          this.form.remind_time = moment(startTime).subtract(5, 'minutes')
        } else if (this.form.remind_time_id === 3) {
          this.form.remind_time = moment(startTime).subtract(15, 'minutes')
        } else if (this.form.remind_time_id === 4) {
          this.form.remind_time = moment(startTime).subtract(30, 'minutes')
        } else if (this.form.remind_time_id === 5) {
          this.form.remind_time = moment(startTime).subtract(1, 'hours')
        } else if (this.form.remind_time_id === 6) {
          this.form.remind_time = moment(startTime).subtract(1, 'days')
        }
        this.form.remind_time = moment(this.form.remind_time).format('YYYY-MM-DD HH:mm')
      }
      // 格式化时间字符串
      this.form.start_time = moment(this.form.start_time).format('YYYY-MM-DD HH:mm')
      this.form.end_time = moment(this.form.end_time).format('YYYY-MM-DD HH:mm')
    },
    cancelDialog () {
      this.cleanFormData()
      let data = {
        visible: false,
        method: '',
        no: ''
      }
      this.$store.dispatch('setScheduleDialog', data)
    },
    cleanFormData () {
      this.form.user_no = this.$store.state.userInfo.user_no
      this.form.create_user = this.$store.state.userInfo.user_no
      this.form.title = ''
      this.form.content = ''
      this.form.category = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form.team_no = ''
      this.form.cycle = 0
      this.form.remind_time = ''
      this.form.remind_time_id = ''
      this.addProjectDialogVisible = false
      this.category_list = []
      this.remind_time_list = []
    }
  }
}
</script>

<style lang="stylus">
  // .addSchedule
  //   .cover
  //     position fixed
  //     top 0
  //     left 0
  //     width 100%
  //     height 100%
  //     background rgba(0, 0, 0, 0.7)
  //     z-index 30
  //   .dialog
  //     position fixed
  //     top: 10%
  //     left 35%
  //     width 33.75rem
  //     height 40.625rem
  //     z-index 50
  //     border-radius 0.125rem
  //     box-shadow 0 0.0625rem 0.1875rem $tinGrey
  //     background $white
  .addSchedule
    .el-dialog
      width 33.75rem
      // height 41.1875rem
      .el-dialog__header
        display none
      .el-dialog__body
        padding 0 1.25rem 1rem 1.25rem
        .title
          height 3.4375rem
          line-height 3.4375rem
          text-align center
          font-size 1.125rem
          font-weight 500
        .form_body
          input::-webkit-input-placeholder,textarea::-webkit-input-placeholder
            /* WebKit browsers */
            color $lightGrey
          input:-moz-placeholder,textarea:-moz-placeholder
            /* Mozilla Firefox 4 to 18 */
            color $lightGrey
          input::-moz-placeholder,textarea::-moz-placeholder
            /* Mozilla Firefox 19+ */
            color $lightGrey
          input::-ms-input-placeholder,textarea::-ms-input-placeholder
            /* Internet Explorer 10+ */
            color $lightGrey
        .form_body
          color $lightGrey
          .el-input.is-disabled .el-input__inner,
          .el-range-editor.is-disabled,
          .el-range-editor.is-disabled .el-range-input,
          .el-textarea.is-disabled .el-textarea__inner
            background $white
            background-color $white
          .form_buttons
            text-align right
            margin 1rem 0 0 0
            .el-button--medium
              padding 6px 11px
              font-size 16px
              i
                margin-left 5px
                font-size 16px
            .cancel_btn
              border none
              outline none
              background transparent
          .el-form-item.type_form_item
            margin-bottom 1rem
          .el-form-item.schedule_content,.el-form-item.start_end_time
            .el-form-item__content
              height 40px
              line-height 40px
              .el-input__inner
                height 39px
                padding 0.31256rem
                border none
                outline none
          .el-form-item.schedule_mark
            height 4.6rem
            .el-form-item__content
              height 4.6rem
              .el-textarea__inner
                border none
                outline none
                padding 0.31256rem
                resize none
          .el-form-item
            margin-bottom 0
            .el-form-item__content
              height 2.5rem
              line-height 2.5rem
              display flex
              .label_icon
                flex 1
                font-size 1rem
                font-weight 900
                color $lightGrey
              .sub_title
                flex 3
              .date_picker,.el-select,.sub_title_2
                overflow hidden
                flex 9
                text-align right
                input
                  height 2.5rem
                  // width 13.75rem
                  padding 0
                  border none
                  text-align right
              .date_picker
                .el-date-editor.el-input,.el-date-editor--datetimerange.el-input__inner
                  width 100%
                  text-align right
                .el-date-editor--datetimerange.el-input__inner
                  display inline-block
                  padding 0
                  .el-range-input,.el-range-separator
                    display inline-block
                    vertical-align middle
                    height 39px
                    line-height 39px
                    text-align right
                  .el-range-input
                    width 36%
                  .el-input__icon
                    display none
              .takeplace
                flex 3
              span.el-input__prefix,.el-input__suffix
                display none
              span.el-input__suffix
                left 5px
              .el-radio-button
                outline none
                border none
                .el-radio-button__inner
                  width 1.875rem
                  height 1.875rem
                  border-radius 50%
                  padding 0
                  font-size 0.625rem
                  line-height 1.875rem
                  text-align center
              .el-radio-button:not(:last-child)
                margin-right 2rem
              .team_no_select,.remind_time_id_select
                .el-input__suffix
                  display inline-block
                  text-align left
                  .el-icon-arrow-up
                    display none
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/dialogSchedule.vue